// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"332":"13e3c921","354":"667f7c7b","418":"54f7aff9"}[chunkId] + ".js";
};